import React, { Component } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { Navigate } from "react-router-dom";
import {
  Button,
  TextField,
  Typography,
  Alert,Collapse,
  Box,
  Select
} from "@mui/material";

import Autocomplete from "@mui/material/Autocomplete";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import PhotoCamera from "@mui/icons-material/PhotoCamera";

import SubmitIcon from "./images/SUBMIT-ICON.jpg";
import Serverurl from "./Apiurl";

class MaterialprocurementForm extends Component {
  constructor(props) {
    super(props);

 

    this.state = {
      type: "Materialprocurement",
     
      materialRecordId:  "0",

      materialarrauto: [],
      selectedMaterialInsert: null,
      existingFile:"",
	  existingImage:"",
	  pi_pj_id: "",
	  previocn : "",

      venderarrauto: [],
      selectedVenderInsert: [],
      mp_vm_id: "",

	  materialImage:"",
      projectarrauto:[],  selectedProjectInsert: '',
	  mp_id: "",
      mp_date: dayjs(),
      mp_amount: 0,
      mp_remarks: "",
	  mp_wc_id: "0",
	mp_vm_id: "",
		
		mp_remarks: "",
	mp_units: "",
	mp_date: dayjs(),
	mp_quantity: "",
	mp_pj_id: "0",

	  expenseFile:"",
	  
	redirect:false,pagename:"",
      
	  submitbtn: "Submit",
      isDisabled: false,
      loading: false,

      successMsg: "",
      errormessage: "",
      erropen: false,
      errorty: "error"

    };
  }

  componentDidMount() {
	  		if(localStorage.getItem("VRuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Userlogin'
          })
		  }
	let strname="Material Procurement Entry";   
			 this.props.parentsCallback(
           strname
        );
     const params = new URLSearchParams(window.location.search);
    const materialId = params.get("mp_id");

   if(materialId!=null){
      this.loadMaterialProcrumnentdata(materialId);
    }
  }


loadMaterialProcrumnentdata = (id) => {

  axios.get(Serverurl + "ajaxmaterialprocurement.php", {
	params: {
	  action: "getdatafordisplay",
	  mp_id: id,
	  mp_wc_id: "",
	  mp_vm_id: "",
	  mp_pj_id: "",
	  mp_date: "",
	  index: 0,
	  maxrecrd: 50,
	  orderby: "mp_id DESC"
	}
  })
  .then((res) => {
	 
    if (res.data.length > 0) {
      
      this.setState({
	  materialRecordId: res.data[0].mp_id,
	  mp_id: res.data[0].mp_id,
mp_pj_id: res.data[0].mp_pj_id,
	  selectedMaterialInsert: {title: res.data[0].wc_categoryname,wc_id: res.data[0].mp_wc_id},
	  mp_wc_id: res.data[0].mp_wc_id,
	  mp_date: dayjs(res.data[0].mp_date),
	  mp_quantity: res.data[0].mp_quantity,
	  mp_units: res.data[0].mp_units,mp_amount:res.data[0].mp_amount,
	  mp_remarks: res.data[0].mp_remarks,
	  selectedVenderInsert: {title: res.data[0].vm_vendorname,vm_id: res.data[0].mp_vm_id},
	  selectedProjectInsert:{title: res.data[0].pj_projectname,pj_id: res.data[0].mp_pj_id},
	  mp_vm_id: res.data[0].mp_vm_id,
	  existingImage: res.data[0].mp_image,
	  existingFile: res.data[0].mp_bill
	});
    }
  })
  .catch((error) => {
    this.setState({
     
    });
  });
};


onProjectChange = (event, value) => {
  this.setState({
    selectedProjectInsert: value,
    mp_pj_id: value ? value.pj_id : ""
  });
};
onloadProjectBind = (event) => {
    const projectName = event?.target?.value?.trim() || "";

    if (!projectName) {
      this.setState({
        projectarrauto: []
      });
      return;
    }

    axios
      .get(Serverurl + "ajaxprojects.php", {
        params: {
          action: "getallprojectautoextender",
          projectname: projectName
        }
      })
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];

        const list = data.map((r) => ({
          title: r.pj_projectname || "",
          pj_id: r.pj_id,
          finalized: Number(r.pj_finalizedamount) || 0
        }));

        this.setState({
          projectarrauto: list
        });
      })
      .catch((error) => {
        console.error("Error loading projects:", error);

        this.setState({
          projectarrauto: []
        });
      });
  };
onloadMaterialBind = (event) => {

  const materialName = event?.target?.value?.trim() || "";

  if (materialName.length < 2) {
    this.setState({
      materialarrauto: []
    });

    return;
  }

  axios.get(Serverurl + "ajaxmaterialprocurement.php",
    {
      params: {
        action: "materialprocautoextender",
        materialname: materialName
      }
    }
  )
  .then((res) => {

    const data = Array.isArray(res.data)
      ? res.data
      : [];

    const list = data.map((r) => ({
      title: r.wc_categoryname || "",
      wc_id: r.wc_id
    }));

    this.setState({
      materialarrauto: list
    });
  })
  .catch((error) => {
    this.setState({
      materialarrauto: []
    });
  });
};


  onloadVenderBind = (event) => {

    const venderName = event?.target?.value?.trim() || "";
	
	
	  if (venderName.length < 2) {
    this.setState({
      venderarrauto: []
    });

    return;
  }

    axios.get(
        Serverurl +"ajaxtransactions.php",
        {
          params: {
            action: "vendortypeautoextender",
            vm_vendorname: venderName,
			vm_type:"2",ts_pj_id:this.state.mp_pj_id
          }
        }
      )
      .then((res) => {

        const data =
          Array.isArray(res.data)
            ? res.data
            : [];

        const list =
          data.map((r) => ({
            title:r.vm_vendorname || "",
			vm_se_id:r.vm_se_id,
            vm_id:r.vm_id
			
          }));

        this.setState({
          venderarrauto: list
        });

      })
      .catch((error) => {
	  })

        this.setState({
          venderarrauto: []
        });

  };


onMaterialChange = (event, value) => {

  if (typeof value === "string") {
    this.setState({
      selectedMaterialInsert: value,
      mp_wc_id: 0
    });
  } else {
    this.setState({
      selectedMaterialInsert: value,
      mp_wc_id: value ? value.wc_id : 0
    });
  }

};

	onVenderChange = (event, value) => {
    this.setState({
      selectedVenderInsert: value,
      mp_vm_id: value ? value.vm_id : "",
      
    });
  };

	onFileChange = (e) => {
	
	  let expenseupFile =e.target.files[0];

	  if (!expenseupFile || expenseupFile.length === 0) {
		return;
	  }

	  if (expenseupFile.type.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG|pdf|doc|xls)$/)) {
		this.setState({ errormessage: "Please select a .xls,.doc,.pdf,.jpg", erropen: true, errorty: "error", expenseFile: null });
		e.target.value = "";
		return;
	  }

	  if (expenseupFile.size > 900 * 1024) {
		this.setState({ errormessage: "File size should be less than or equal to 900KB.", erropen: true, errorty: "error", expenseFile: null });
		e.target.value = "";
		return;
	  }

	  this.setState({ expenseFile: expenseupFile, errormessage: "", erropen: false },()=>{});
	}; 

	onImageChange = (e) => {
	  let imageFile = e.target.files[0];

	  if (!imageFile || imageFile.length === 0) {
		return;
	  }

	  if (!imageFile.name.match(/\.(jpg|jpeg|png|JPG|JPEG|PNG)$/)) {
		this.setState({ errormessage: "Please select a valid file (jpg, jpeg, png).", erropen: true, errorty: "error" });
		window.scrollTo({ top: 0 });
		return false;
	  }

	  if (imageFile.size > 900*1024) {
		this.setState({ errormessage: "File size should be less than or equal to 900KB.", erropen: true, errorty: "error" });
		window.scrollTo({ top: 0 });
		return false;
	  }

	  this.setState({ expenseImage: imageFile, errormessage: "", erropen: false });
	};

	handeldate = (date) => {
	  var month = "";
	  var date1 = new Date(date);

	  if ((date1.getMonth() + 1) < 10) {
		month = "0" + (date1.getMonth() + 1);
	  } else {
		month = date1.getMonth() + 1;
	  }

	  this.setState({mp_date: dayjs(date)});
	};
	

	handleErrorclose = () => {
    this.setState({
      erropen: false
    });
  };
 myChangeHandler = (event) => {
	  
	 
	    const re = /^[0-9.\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  

  if(nam==="mp_amount" || nam==="mp_quantity"  )
  {
	  if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
	  }
  }
 
    else{
  this.setState({[nam]: val});
  }

    
  };
 

insertMaterialsItems = () => {
  const {
  mp_id,
  mp_pj_id,
  mp_wc_id,
  mp_vm_id,
  mp_date,
  mp_quantity,
  mp_remarks,mp_amount,
  mp_units,
  selectedMaterialInsert
} = this.state;

const material = typeof selectedMaterialInsert === "string" ? selectedMaterialInsert : selectedMaterialInsert?.title;
  

if (!material) {
  this.setState({
    errormessage: "Please Enter Material",
    erropen: true,
    errorty: "error"
  });
  return false;
}

  if (!mp_vm_id) {
    this.setState({
      errormessage: "Please Select Vender",
      erropen: true,
      errorty: "error"
    });
    return false;
  }

  if (!mp_date || !dayjs(mp_date).isValid()) {
    this.setState({
      errormessage: "Please Select a Valid Date",
      erropen: true,
      errorty: "error"
    });
    return false;
  }

  if (!mp_quantity) {
    this.setState({
      errormessage: "Please Enter Quantity",
      erropen: true,
      errorty: "error"
    });
    return false;
  }

  if (!mp_units || Number(mp_units) === 0) {
    this.setState({
      errormessage: "Please Select Unit",
      erropen: true,
      errorty: "error"
    });
    return false;
  }
   if (!mp_amount || Number(mp_amount) === 0) {
    this.setState({
      errormessage: "Please Enter Amount",
      erropen: true,
      errorty: "error"
    });
    return false;
  }
  

  this.setState({
    isDisabled: true,
    submitbtn: "Processing...",
    errormessage: "",
    erropen: false
  });

  let formData = new FormData();

  formData.append("action", "insert");
  formData.append("mp_id", mp_id || 0);
  formData.append("mp_date", dayjs(mp_date).format("YYYY-MM-DD"));
  formData.append("mp_material", material);
  formData.append("mp_pj_id", mp_pj_id );
  formData.append("mp_wc_id", mp_wc_id );
 formData.append("mp_vm_id", mp_vm_id);
  formData.append("mp_quantity", mp_quantity);
  formData.append("mp_amount", mp_amount);
  formData.append("mp_remarks", mp_remarks);
  formData.append("mp_units", mp_units);
  formData.append("userid", localStorage.getItem("VRuserid"));

  if (this.state.existingImage==="") {
    formData.append("mp_image", this.state.expenseImage);
  } else if (this.state.existingImage) {
    formData.append("mp_image", this.state.existingImage);
  }

  if (this.state.existingFile==="") {
    formData.append("mp_bill", this.state.expenseFile);
  } else if (this.state.existingFile) {
    formData.append("mp_bill", this.state.existingFile);
  }

  axios.post(Serverurl + "ajaxmaterialprocurement.php",formData)
  .then((res) => {this.setState({isDisabled: false,submitbtn: "Submit",
errormessage: "Material procurement submitted successfully!",erropen: true,errorty: "success",redirect: true,pagename: "/Projectwise-materials"
    });
  })
  .catch((error) => {
    this.setState({
      isDisabled: false,
      submitbtn: "Submit",
      errormessage: "Unable to submit material procurement.",
      erropen: true,
      errorty: "error"
    });
  });
};
  
  
  render() {
	  
	  if (this.state.redirect === true) {
    return <Navigate to={this.state.pagename} />;
  }
	  
    return (
      <React.Fragment>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box>
            {this.state.loading && (
              <Alert severity="info" sx={{ mb: 2 }}>
                Loading expense details...
              </Alert>
            )}
 <Collapse in={this.state.erropen}>
          
              <Alert
                severity={
                  this.state.errorty === "success"
                    ? "success"
                    : "error"
                }
                onClose={this.handleErrorclose}
                sx={{ mb: 2 }}
              >
                {this.state.errormessage}
              </Alert>
        	 </Collapse>

<div className="txtprojfrm">
<p>
           
              Project </p> 

               <p>  <Autocomplete
			     tabIndex={1} 
                className="inputcntlparent"
                options={this.state.projectarrauto}
                value={this.state.selectedProjectInsert}
                onChange={this.onProjectChange}
                getOptionLabel={(option) => option?.title || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.pj_id === value?.pj_id
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    fullWidth
                    placeholder="Select Project"
                    onChange={this.onloadProjectBind}
					
                  />
                )}
              />   </p>
            </div>
			 <div className="txtprojfrmryt">
              <p>Vender</p>
 <p>
              <Autocomplete
                className="inputcntlparent"
                options={this.state.venderarrauto}
                value={this.state.selectedVenderInsert}
                onChange={this.onVenderChange}
                getOptionLabel={(option) => option?.title || ""}
                isOptionEqualToValue={(option, value) =>
                  option?.vm_id  === value?.vm_id 
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    size="small"
                    fullWidth
                    placeholder="Select Vender"
					 onChange={this.onloadVenderBind}
					
                  />
                )}
              /></p>
            </div>
			 <div className="clear"></div>
           <div className="txtprojfrm">
<p>Material</p>

           <p>   <Autocomplete
			  className="inputcntlparent"
			  freeSolo
			  options={this.state.materialarrauto}
			  value={this.state.selectedMaterialInsert}

			  onChange={this.onMaterialChange}

			  onInputChange={(event, value) => {

				this.setState({
				  selectedMaterialInsert: value
				});

				this.onloadMaterialBind({target: {value: value}});

			  }}

			  getOptionLabel={(option) => {
				if (typeof option === "string") {
				  return option;
				}

				return option?.title;
			  }}

			  isOptionEqualToValue={(option, value) =>
				option?.wc_id === value?.wc_id
			  }

			  renderInput={(params) => (
				<TextField
				  {...params}
				  size="small"
				  fullWidth
				  placeholder="Select Material"
				/>
			  )}
			/></p>
            </div>


       
			
<div className="txtprojfrmryt">		
			<p>Quantity</p>			
			<p>	<TextField
                    size="small"
                    name="mp_quantity"
                    placeholder="Quantity"
                    value={this.state.mp_quantity}
					onChange={this.myChangeHandler}
                  /> <Select
				className="inputcntlparent"
				size="small"
				variant="outlined"
				native label="Units"   
				value={this.state.mp_units}
			 onChange={this.myChangeHandler}
				name="mp_units"
				id="Units"
			  >
				<option value={0}>Select Unit</option>
				<option value={1}>KG</option>
				<option value={2}>TON</option>
				<option value={3}>BAG</option>
					<option value={4}>CFT</option>
					<option value={5}>M3</option>
			<option value={6}>SQFT</option>
					<option value={7}>MTR</option>
					<option value={8}>Running Feet</option>
					<option value={9}>NOS</option>
					<option value={10}>LTR</option>
					<option value={11}>Bundle</option>
					<option value={12}>Sheet</option>
			  </Select></p>	
			</div>
			
		 
				 <div className="clear"></div>
			

			
			<div className="txtprojfrm">
			<p>Amount</p>
			<p><TextField
                    size="small"
                    fullWidth name="mp_amount"
                    placeholder="Amount"
                    value={this.state.mp_amount}
onChange={this.myChangeHandler}
                  /></p>
			 </div>
			<div className="txtprojfrmryt">
              <p>Date</p>
    <p>
              <DatePicker
                disableFuture
                className="inputcntlparent"
                format="DD/MM/YYYY"
                value={this.state.mp_date}
                onChange={this.handeldate}
                slotProps={{
                  textField: {
                    size: "small",
                    fullWidth: true
                  }
                }}
              /></p>
            </div>
 <div className="clear"></div>

         <div className="txtprojfrm">

       
              <p>Upload Image</p>

              <p className="upload-submitimg">
                <Button
                  variant="outlined"
                  className="upldbtn"
                  endIcon={<PhotoCamera />}
                  component="label"
                >
                  Upload Image

                  <input
                    id="expense-image-input"
                    type="file"
                    hidden
                    name="mp_image"
                    accept="image/jpeg,image/jpg,image/png"
                    onChange={this.onImageChange}
                  />
                </Button>
              </p>

              {this.state.expenseImage && (
                <Typography variant="body2">
                  Selected Image:{" "}
                  <strong>
                    {this.state.expenseImage.name}
                  </strong>
                </Typography>
              )}

              {this.state.existingImage && (
                <Box sx={{ mt: 1 }}>
                  <Typography variant="body2">
                    Existing Image:
                  </Typography>

                  <img
                    src={Serverurl +"uploads/" +this.state.existingImage} style={{width:"80px"}}
                    alt="Existing expense"
                  />
                </Box>
              )}
            </div>
	
           	<div className="txtprojfrmryt">
              <p>Upload File</p>

              <p className="upload-submitimg">
                <Button
                  variant="outlined"
                  className="upldbtn"
                  component="label"
                >
                  Choose File

                  <input
                    id="expense-file-input"
                    type="file"
                    hidden
                    name="mp_bill"
                    onChange={this.onFileChange}
                  />
                </Button>
              </p>

              {this.state.expenseFile && (
                <Typography variant="body2">
                  Selected File:{" "}
                  <strong>
                    {this.state.expenseFile.name}
                  </strong>
                </Typography>
              )}

              {this.state.existingFile && (
                <Typography variant="body2">
                  Existing File:{" "}
				    <a
                    href={Serverurl +"uploads/" +this.state.existingFile} style={{width:"80px"}}
                    
                  >View</a>
                 
                </Typography>
              )}
            </div>

           <div className="clear"></div>


         <div className="txtprojfrm">
                <p>Remarks</p>

             <p>   <TextField
                  fullWidth
                  size="small" name="mp_remarks"
                  multiline
                  minRows={3}
                  value={this.state.mp_remarks}
                onChange={this.myChangeHandler}
                  placeholder="Enter remarks"
                /></p>
              </div>

      	 <div className="clear"></div>

            <div className="aligncenter">
              <Button
                variant="contained"
                disabled={
                  this.state.isDisabled ||
                  this.state.loading
                }
                onClick={this.insertMaterialsItems}
                endIcon={
                  <img
                    src={SubmitIcon}
                    alt="Submit"
                    style={{
                      width: 20,
                      height: 20
                    }}
                  />
                }
              >
                {this.state.submitbtn}
              </Button>
            </div>
          </Box>
        </LocalizationProvider>
      </React.Fragment>
    );
  }
}

export default MaterialprocurementForm;

